import Request from 'utils/request.js';

const MANAGEMENT_BASE_URL = 'management/auth/login';

export const login = (data) => Request.post(MANAGEMENT_BASE_URL, data);
